/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p-dropdown{display:block}  p-dropdown .p-dropdown{display:flex;background-color:#f4f5f5;border:0}"];
export { styles as styles };
